<template>
    <div class="container height-100 py-2" style="max-width: 900px;">
        <div class="header-calculation-wrap">
            <div class="accordion">
                <div class="accordion-item">
                    <h2 class="accordion-header">
                        <button class="accordion-button no_after" type="button">
                            {{ $helper.trans('Shipment_information') }}
                        </button>
                    </h2>
                    <div class="accordion-collapse">
                        <div class="accordion-body">
                            <div class="row">
                                <div class="col-12">
                                    <div class="value-column column-4">
                                        <label class="font-weight-bold">{{ $helper.trans('Shipments_count') }}</label>
                                        <div class="value-wrap" style="width: 125px;">
                                            <button type="button" @click="trackingNumbersCount--" class="btn-down"></button>
                                            <input type="number" v-model="trackingNumbersCount" />
                                            <button type="button" @click="trackingNumbersCount++" class="btn-up"></button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-2" v-for="trackingIndex in trackingNumbersCount" :key="trackingIndex">
                                <div class="col-12 col-sm">
                                    <label class="font-weight-bold mb-0">{{ $helper.trans('Tracking_number') }}: *</label>
                                    <input type="text" placeholder="1Z..." class="input-big mt-0 w-100" :class="`trackingNumbers_${trackingIndex - 1}_input`" v-model="trackingNumbers[trackingIndex - 1]" />
                                </div>
                                <div class="col-12 col-sm-auto" v-if="trackingIndex === trackingNumbersCount">
                                    <div class="send-block button-block">
                                        <button class="btn btn-yellow radius-4 w-100" @click="checkTrackingNumbers();" style="margin-top: 2px;">{{ $helper.trans('Check') }}</button>
                                    </div>
                                </div>

                                <div class="col-12 mt-1" v-show="validNumbers[trackingIndex - 1] === 1">
                                    <label class="strong-label mb-0">{{ $helper.trans('Description_of_shipment') }}: *</label>
                                    <div class="w-100 mt-0">
                                        <textarea class="returnInformation_description_input w-100" :class="`shipmentDescriptions_${trackingIndex - 1}_input`" style="padding: 24px; height: 84px;" v-model="shipmentDescriptions[trackingIndex - 1]" :placeholder="$helper.trans('Summarize_description_of_shipment_in_English')"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="accordion-item" v-if="atLeastOneValid()">
                    <h2 class="accordion-header">
                        <button class="accordion-button no_after" type="button">
                            {{ $helper.trans('Pickup_address') }}
                        </button>
                    </h2>
                    <div class="accordion-collapse">
                        <div class="accordion-body">
                            <div class="row">
                                <div class="col-12">
                                    <label class="font-weight-bold">{{ $helper.trans('Pickup_address') }}:</label>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="mb-3">
                                        <input type="text" v-model="returnInformation.name" :placeholder="'* ' + $helper.trans('Company_or_firstname_lastname')" class="input-big w-100 returnInformation_name_input">
                                    </div>

                                    <div class="mb-3">
                                        <input type="text" v-model="returnInformation.contactPerson" :placeholder="'* ' + $helper.trans('Contact_person')" class="input-big w-100 returnInformation_contactPerson_input">
                                    </div>

                                    <div class="mb-3">
                                        <input type="text" v-model="returnInformation.phone" :placeholder="'* ' + $helper.trans('Phone_number')" class="input-big w-100 returnInformation_phone_input">
                                    </div>

                                    <div class="mb-3">
                                        <input type="text" v-model="returnInformation.email" :placeholder="$helper.trans('Contact_email')" class="input-big w-100 returnInformation_email_input">
                                    </div>

                                    <div class="mb-3">
                                        <input type="text" v-model="returnInformation.address1" :placeholder="'* ' + $helper.trans('Address') + ' 1'" class="input-big w-100 returnInformation_address1_input">
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="mb-3">
                                        <input type="text" v-model="returnInformation.address2" :placeholder="$helper.trans('Address') + ' 2'" class="input-big w-100 returnInformation_address2_input">
                                    </div>

                                    <div class="mb-3">
                                        <input type="text" v-model="returnInformation.address3" :placeholder="$helper.trans('Address') + ' 3'" class="input-big w-100 returnInformation_address3_input">
                                    </div>

                                    <div class="mb-3">
                                        <input type="text" :value="$helper.trans('Lithuania')" disabled class="input-big w-100">
                                    </div>

                                    <div class="mb-3">
                                        <input type="text" v-model="returnInformation.postCode" @blur="getPickupTime()" :placeholder="'* ' + $helper.trans('Post_code')" class="input-big w-100 returnInformation_postCode_input">
                                    </div>

                                    <div class="mb-3">
                                        <input type="text" v-model="returnInformation.city" :placeholder="'* ' + $helper.trans('City')" class="input-big w-100 returnInformation_city_input">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="accordion-item" v-if="atLeastOneValid()">
                    <h2 class="accordion-header">
                        <button class="accordion-button no_after" type="button">
                            {{ $helper.trans('Courier_call') }}
                        </button>
                    </h2>
                    <div class="accordion-collapse">
                        <div class="accordion-body">
                            <div class="row">
                                <div class="col-12 mt-3" v-show="atLeastOneValid()">
                                    <label class="strong-label">{{ $helper.trans('Courier_arrival_time') }}:</label>
                                </div>

                                <div class="col-12 col-md-6" v-show="atLeastOneValid()">
                                    <div class="option-column column-space-small datepicker-container">
                                        <input 
                                            id="carrier_datepicker" 
                                            type="text" 
                                            :placeholder="$helper.trans('Pickup_date')" 
                                            class="input-big js_form-input carrierInfo_carrierDate_input w-100" 
                                            v-model="carrierDate" 
                                            :data-custom-datepicker-settings="JSON.stringify(datepickerCustomSettings)"
                                        >
                                    </div>
                                </div>

                                <div class="col-12 col-md-3" v-show="atLeastOneValid()">
                                    <select2-component :values="pickUpStartTimesArray" :placeholder="$helper.trans('Pickup_time_start')" :noLang="true" classes="input-big select-style-ups carrierInfo_carrierTimeFrom_input" v-model="carrierTimeFrom" specialName="carrierPickupTimeStart"></select2-component>
                                </div>

                                <div class="col-12 col-md-3" v-show="atLeastOneValid()">
                                    <select2-component :values="pickUpEndTimesArray" :placeholder="$helper.trans('Pickup_time_end')" :noLang="true" classes="input-big select-style-ups carrierInfo_carrierTimeTo_input" v-model="carrierTimeTo" specialName="carrierPickupTimeEnd"></select2-component>
                                </div>

                                <div class="col-12 mt-4" v-show="atLeastOneValid()">
                                    <div class="packet-row packet-column packet-textarea">
                                        <label class="strong-label" style="display: flex;">{{ $helper.trans('Additional_notes_for_courier') }}</label>
                                        <textarea style="padding: 24px; height: 84px; max-width: 815px; width: 100%;" class="carrierInfo_notesToCarrier_input" v-model="notesToCarrier" :placeholder="$helper.trans('Door_code_specifying_how_to_find_address')"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12" v-show="atLeastOneValid()">
                        <div class="col-12 col-sm-auto mb-2">
                            <div class="send-block button-block">
                                <button class="btn btn-yellow radius-4" @click="submitReturn();">{{ $helper.trans('Submit_return') }}</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12" v-show="successMessage">
                        <div class="alert alert-success">{{ $helper.trans('Shipment_return_created_successfully') }}</div>
                    </div>
                    <div class="col-12" v-show="errorMessage">
                        <div class="alert alert-danger">{{ $helper.trans('Non_serviceable_area_error_message') }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data: function () {
        return {
            routes: {},
            pickupInformation: {
                latestOrderTime: '',
                earliestPickupTime: '',
                latestPickupTime: '',
                minimumInterval: '',
                mustUseCarrierSticker: '',
            },
            carrierDate: '',
            carrierTimeFrom: '',
            carrierTimeTo: '',
            notesToCarrier: '',
            timeStep: 10, // In minutes
            datepickerCustomSettings: {
                minDate: '',
                noWeekends: true,
            },
            trackingNumbersCount: 1,
            trackingNumbers: ['', '', '', ''],
            validNumbers: [0, 0, 0, 0],
            shipmentDescriptions: ['', '', '', ''],
            returnInformation: {
                name: '',
                contactPerson: '',
                phone: '',
                email: '',
                address1: '',
                address2: '',
                address3: '',
                postCode: '',
                city: '',
            },
            successMessage: false,
            errorMessage: false,
            phoneRegex: new RegExp(/[a-zą-ž]/gi),
        };
    },
    props: {
        routesJson: {
            type: String,
            required: true,
        }
    },
    created: function () {
        this.routes = JSON.parse(Base64.decode(this.routesJson));

        this.datepickerCustomSettings.minDate = moment().format('YYYY-MM-DD');

        this.datepickerCustomSettings.holidays =
            [
                new Date(new Date().getFullYear() + '-01-01'),
                new Date(new Date().getFullYear() + '-02-16'),        
                new Date(new Date().getFullYear() + '-03-11'),
                window.getEasterDate(new Date().getFullYear()),
                new Date(new Date().getFullYear() + '-05-01'),
                new Date(new Date().getFullYear() + '-06-24'),
                new Date(new Date().getFullYear() + '-07-06'),
                new Date(new Date().getFullYear() + '-08-15'),
                new Date(new Date().getFullYear() + '-11-01'),
                new Date(new Date().getFullYear() + '-12-24'),
                new Date(new Date().getFullYear() + '-12-25'),
                new Date(new Date().getFullYear() + '-12-26')
            ];

        this.getPickupTime();
    },
    methods: {
        checkTrackingNumbers: function () {
            let vueThis = this;

            $('.ups-danger-text').remove();
            $('.alert-danger-ups').removeClass('alert-danger-ups');
            $('.custom-ups-error-parent').removeClass('custom-ups-error-parent');

            vueThis.successMessage = false;

            let url = vueThis.routes['api.check_tracking_numbers'];
            let data = {
                trackingNumbers: vueThis.trackingNumbers.slice(0, vueThis.trackingNumbersCount)
            };
            axios.post(url, data)
                .then(function (response) {
                    for (let i = 0; i < vueThis.trackingNumbersCount; i++) {
                        vueThis.validNumbers[i] = 1;
                    }
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: 'return_tracking_found',
                        tracking_number: vueThis.trackingNumbers.join(', '),
                        tracking_status: 'found'
                    });
                }).catch(function (error) {
                    if (error.response.status === 422) {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            event: 'return_tracking_found',
                            tracking_number: vueThis.trackingNumbers.join(', '),
                            tracking_status: 'not_found'
                        });

                        for (let i = 0; i < vueThis.trackingNumbersCount; i++) {
                            vueThis.validNumbers[i] = 1;
                        }

                        $.each(error.response.data.errors, function (errorKey, errorText) {
                            $(`.${errorKey.replaceAll('.', '_')}_input`)
                                .addClass('alert-danger-ups')
                                .parent()
                                .addClass('custom-ups-error-parent')
                                .append(`<span class="ups-danger-text ml-3">${errorText[0]}</span>`);

                            vueThis.validNumbers[errorKey.slice(-1)] = 2;
                        });
                    } else {
                        console.error(error);
                    }
                }).finally(function () {
                    vueThis.$forceUpdate();
                    vueThis.getPickupTime();
                });
        },
        submitReturn: function () {
            $('.ups-danger-text').remove();
            $('.alert-danger-ups').removeClass('alert-danger-ups');
            $('.custom-ups-error-parent').removeClass('custom-ups-error-parent');

            let vueThis = this;
            let url = vueThis.routes['api.submit_return'];
            let data = {
                trackingNumbers: vueThis.trackingNumbers.slice(0, vueThis.trackingNumbersCount),
                returnInformation: vueThis.returnInformation,
                shipmentDescriptions: vueThis.shipmentDescriptions.slice(0, vueThis.trackingNumbersCount),
                carrierInfo: {
                    invoiceDeliveryType: 'pdf',
                    callCarrier: true,
                    carrierDate: vueThis.carrierDate,
                    carrierTimeFrom: vueThis.carrierTimeFrom,
                    carrierTimeTo: vueThis.carrierTimeTo,
                    notesToCarrier: vueThis.notesToCarrier,
                },
                from: {
                    postCode: vueThis.returnInformation.postCode,
                    country: 'lt',
                }
            };

            axios.post(url, data)
                .then(function (response) {
                    vueThis.successMessage = true;
                }).catch(function (error) {
                    if (error.response.status === 422) {
                        $.each(error.response.data.errors, function (errorKey, errorText) {
                            let inputName = `.${errorKey.replaceAll('.', '_')}_input`;

                            let input = $(inputName);
                            if (input.length > 0) {
                                $(inputName).addClass('alert-danger-ups').parent().addClass('custom-ups-error-parent').append(`<span class="ups-danger-text ml-3">${errorText[0]}</span>`);
                            } else {
                                showToast(errorText[0], "#c91a13", 30000);
                            }
                        });
                    } else if (error.response.status === 400) {
                        vueThis.validNumbers = [0, 0, 0, 0];
                    } else if (error.response.status === 419) {
                        vueThis.errorMessage = true;
                    }
                    vueThis.successMessage = false;
                });
        },
        getMinutesFromHours: function (hours) {
            let hoursSplit = hours.split(':');
            return parseInt(hoursSplit[1]) + parseInt(hoursSplit[0]) * 60;
        },
        getHoursFromMinutes: function (minutes) {
            let minutesPart = Math.round(minutes % 60);
            return Math.floor(minutes / 60).toString().padStart(2, '0') + ':' + minutesPart.toString().padStart(2, '0');
        },
        createTimesArray: function (earliestTimeInt, latestTimeInt) {
            let times = {};
            if (earliestTimeInt <= latestTimeInt) {
                let currentTimeInt = earliestTimeInt;
                let currentTimeHours = this.getHoursFromMinutes(currentTimeInt);
                while (currentTimeInt <= latestTimeInt) {
                    times[currentTimeHours] = currentTimeHours.toString();
                    currentTimeInt += this.timeStep;
                    currentTimeHours = this.getHoursFromMinutes(currentTimeInt);
                }
            }
            return times;
        },
        getPickupTime: function () {
            let vueThis = this;

            let url = vueThis.routes['api.get_pickup_times_by_code'];
            let data = {
                postCode: vueThis.returnInformation.postCode
            };

            axios.post(url, data)
                .then(function (response) {
                    if (!response.data) {
                        vueThis.setEmptyPickupTimes();
                        return;
                    }

                    vueThis.pickupInformation = response.data;
                }).catch(function (error) {
                    console.error(error);
                }).finally(function () {
                    vueThis.setMinDateForCarrier();
                });
        },
        setEmptyPickupTimes: function () {
            this.pickupInformation = {
                latestOrderTime: '00:01',
                earliestPickupTime: '10:00',
                latestPickupTime: '17:00',
                minimumInterval: '02:00',
            };
            this.carrierDate = moment().add(1, 'days').format('YYYY-MM-DD');

            this.setMinDateForCarrier();
        },
        setMinDateForCarrier: function () {
            let vueThis = this;

            if ($('#carrier_datepicker').data('daterangepicker')) {
                $('#carrier_datepicker').data('daterangepicker').remove();
            }

            vueThis.datepickerCustomSettings.minDate = vueThis.minimumCarrierDate;
            vueThis.$nextTick(function () {
                window.initDatePicker($('#carrier_datepicker'));
                $('#carrier_datepicker').on('change', function () {                    
                    vueThis.carrierDate = $(this).val();
                });
            });
        },
        getNextAvailableDay: function (today) {
            let momentToday = moment(today).add(1, 'day');
            if (momentToday.isoWeekday() >= 6) {
                momentToday = momentToday.startOf('isoWeek').add(1, 'week');
            }
            return momentToday.format('YYYY-MM-DD');
        },
        atLeastOneValid: function () {
            for (let i = 0; i < this.trackingNumbersCount; i++) {
                if (this.validNumbers[i] === 1) {
                    return true;
                }
            }
            return false;
        }
    },
    computed: {
        minimumCarrierDate: function () {
            let today = moment().format('YYYY-MM-DD');

            if (this.getMinutesFromHours(this.pickupInformation.latestOrderTime) < this.getMinutesFromHours(moment().format('HH:mm'))) {
                return this.getNextAvailableDay(today);
            }

            return today;
        },
        pickUpStartTimesArray() {
            let vueThis = this;

            let minimumIntervalInt = vueThis.getMinutesFromHours(vueThis.pickupInformation.minimumInterval);
            let earliestTimeInt = vueThis.getMinutesFromHours(vueThis.pickupInformation.earliestPickupTime);
            let latestTimeInt = vueThis.getMinutesFromHours(vueThis.pickupInformation.latestPickupTime) - minimumIntervalInt;

            if (vueThis.carrierDate === moment().format('YYYY-MM-DD')) {
                earliestTimeInt = Math.max(vueThis.getMinutesFromHours(moment().add(5, 'minutes').format('HH:mm')), earliestTimeInt);
            }

            earliestTimeInt = Math.ceil(earliestTimeInt / 10) * 10;

            let times = vueThis.createTimesArray(earliestTimeInt, latestTimeInt);

            vueThis.$nextTick(function () {
                if (!Object.values(times).includes(vueThis.carrierTimeFrom)) {
                    vueThis.carrierTimeFrom = Object.values(times)[0] || null;
                }
            });

            return times;
        },
        pickUpEndTimesArray() {
            let vueThis = this;

            if (empty(vueThis.carrierTimeFrom)) {
                vueThis.carrierTimeTo = null;
                return {};
            }

            let minimumIntervalInt = vueThis.getMinutesFromHours(vueThis.pickupInformation.minimumInterval);
            let earliestTimeInt = vueThis.getMinutesFromHours(vueThis.carrierTimeFrom) + minimumIntervalInt;
            let latestTimeInt = vueThis.getMinutesFromHours(vueThis.pickupInformation.latestPickupTime);

            earliestTimeInt = Math.ceil(earliestTimeInt / 10) * 10;

            let times = vueThis.createTimesArray(earliestTimeInt, latestTimeInt);

            vueThis.$nextTick(function () {
                if (!Object.values(times).includes(vueThis.carrierTimeTo)) {
                    vueThis.carrierTimeTo = Object.values(times).slice(-1)[0] || null;
                }
            });

            return times;
        },
    },
    watch: {
        'returnInformation.phone': function () {
            let phone = this.returnInformation.phone;
            if (phone && this.phoneRegex.test(phone)) {
                this.returnInformation.phone = phone.replaceAll(this.phoneRegex, '');
            }
        },
        trackingNumbersCount: function () {
            if (this.trackingNumbersCount > 4) {
                this.trackingNumbersCount = 4;
            } else if (this.trackingNumbersCount < 1) {
                this.trackingNumbersCount = 1;
            }
        }
    }
}
</script>
